// src/pages/Login/Login.js
import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Login.css';

const Login = () => {
    return (
        <div className="login">
            <Header />
            <div className="content">
                {/* Your Login content */}
            </div>
            <Footer />
        </div>
    );
};

export default Login;
